/*jshint bitwise:false */
define('util/d3Utils',[
], function () {
    'use strict';

    var utils = {
        /**
         * Determine the rendered width of the text node generated from the provided
         * string.
         *
         * @param  {String} str The string of text whose width needs to be calculated
         * @param  {D3 Node} rootNode The root node to perform the calculation in.
         * @param  {String} fontSize The CSS value to use to declare the font size of the
         *  text node to calculate from.
         * @return {Integer} The width of the text that will be rendered in the UI.
         */
        getTextWidth: function (str, rootNode, fontSize) {
            var textNode = rootNode.append("text")
                                   .attr("font-size", fontSize)
                                   .text(str);

            var textWidth = textNode.node().getComputedTextLength();

            textNode.remove();

            return textWidth;
        },

        /**
         * Given a function to acquire the text string from a datum object and a function
         * to determine the max pixel width of the text, this function will be called
         * during D3's data calculation to determine if the provided text for a datum
         * should be truncated. If truncation should occur, the provided text string will
         * be truncated and end with an ellipsid. If truncation should not occur, the
         * provided string will be returned.
         *
         * @param  {Function} text  A function that will return the string that should be
         *  tested for truncation. This function will have two arguments provided to it:
         *      - The data value that is currently being accessed by D3
         *      - The index of the data value object.
         * @param  {Function} width A function that will return the max width that the
         *  provided string should be. This function will have two arguments provided to
         *  it:
         *      - The data value that is currently being accessed by D3
         *      - The index of the data value object.
         * @return {Function} A function that will determine if the string value of a
         *  datum object should be truncated in a given width.
         */
        truncateText: function (text, width) {
            return function(d, i) {
                var t = this.textContent = text(d, i),
                    w = width(d, i);

                if (this.getComputedTextLength() < w) {
                    return t;
                }

                this.textContent = "…" + t;

                var lo = 0,
                    hi = t.length + 1,
                    x;

                while (lo < hi) {
                    var mid = lo + hi >> 1;
                    if ((x = this.getSubStringLength(0, mid)) < w) {
                        lo = mid + 1;
                    } else {
                        hi = mid;
                    }
                }

                return lo > 1 ? t.substr(0, lo - 2) + "…" : "";
            };
        }
    };

    return utils;
});
